import * as React from 'react';
import PricePresentation, { IPricePresentationBase } from '../PricePresentation';
import { IUnitPrice } from '@vp/vp-js-token-engine';

export default class AsLowAsPricePerPiece extends React.Component<IPricePresentationBase<IUnitPrice>> {
  public render(): JSX.Element {
    return (
      <PricePresentation
        classNameWrapper={this.props.classNameWrapper}
        type="asLowAsPricePerPiece"
        pricingInfo={this.props.pricingInfo}
        tenant={this.props.tenant}
        placeHolderText={this.props.placeHolderText}
        isTile={this.props.isTile}
      />
    );
  }
}
